<template>
  <footer class="footer bg-dark text-white">
    <!-- 底部版权 -->
    <div class="footer-bottom bg-secondary py-3">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-8">
            <p class="copyright mb-0">
              © {{ currentYear }} {{ $t('footer.rights') }}
            </p>
            <p class="beian mb-0">
              <a
                class="beian-link"
                href="https://beian.miit.gov.cn"
                target="_blank"
                rel="noopener noreferrer"
              >陕ICP备2025064529号-3</a>
            </p>
          </div>
          <div class="col-md-4 text-md-right">
            <div class="footer-bottom-links">
              <span class="text-white-50">{{ $t('footer.tagline') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.footer-title {
  color: #007bff;
  font-weight: 600;
  margin-bottom: 1rem;
}

.footer-text {
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1rem;
}

.footer-contact p {
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

.footer-links {
  margin: 0;
}

.footer-link {
  color: #ccc;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
  display: block;
  padding: 0.25rem 0;
}

.footer-link:hover {
  color: #007bff;
  text-decoration: none;
}

.footer-qr {
  background: #fff;
  padding: 8px;
  border-radius: 8px;
  display: inline-block;
}

.footer-qr .qr-img {
  width: 130px;
  height: 130px;
  display: block;
}

.subscribe-form .input-group {
  border-radius: 0.25rem;
  overflow: hidden;
}

.subscribe-form .form-control {
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.subscribe-form .form-control::placeholder {
  color: #ccc;
}

.subscribe-form .btn {
  border: none;
  padding: 0.5rem 1rem;
}

.social-links {
  display: flex;
  gap: 0.5rem;
}

.social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 50%;
  text-decoration: none;
  transition: background 0.3s ease;
}

.social-link:hover {
  background: #007bff;
  color: white;
}

.footer-bottom {
  font-size: 0.85rem;
}

.footer-bottom-links a {
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-bottom-links a:hover {
  color: #007bff !important;
}

.copyright {
  color: #ccc;
}

.beian {
  font-size: 0.8rem;
  margin-top: 0.25rem;
}

.beian-link {
  color: #999;
  text-decoration: none;
  transition: color 0.3s ease;
}

.beian-link:hover {
  color: #007bff;
}

@media (max-width: 768px) {
  .footer-bottom .col-md-6 {
    text-align: center !important;
    margin-bottom: 0.5rem;
  }
  
  .footer-bottom-links {
    text-align: center;
  }
}
</style>